import splashI18n from './splashI18n'
import errorCode from './errorcode'
import common from './common'
import webI18n from './webI18n'
import cguI18n from './cguI18n'
import signinI18n from './signinI18n'
import I00DebgazI18n from './I00DebgazI18n'
import I00RELGAZPUISSI18n from './I00RELGAZPUISSI18n'
import I00DIMLIGNEGAZI18n from './I00DIMLIGNEGAZI18n'
import I01EVACONSSYSTECSI18n from './I01EVACONSSYSTECSI18n'
import I01EVACONSSYSTECS2I18n from './I01EVACONSSYSTECS2I18n'
import I01EVAECSQUALII18n from './I01EVAECSQUALII18n'
import I01EVAECSQUALI2I18n from './I01EVAECSQUALI2I18n'
import I01EVAECSQUALI3I18n from './I01EVAECSQUALI3I18n'
import I01TEMPATTI18n from './I01TEMPATTI18n'
import I01DEPBOUCECSI18n from './I01DEPBOUCECSI18n'
import I02CHOIXENERCHAUFI18n from './I02CHOIXENERCHAUFI18n'
import I02COSTENERI18n from './I02COSTENERI18n'
import I03PSYCHROAIRI18n from './I03PSYCHROAIRI18n'
import I04DIMPUISSCHAUDI18n from './I04DIMPUISSCHAUDI18n'
import I04DIMPUISCONSI18n from './I04DIMPUISCONSI18n'
import I04CONVVOLENERI18n from './I04CONVVOLENERI18n'
import I04CONCLIMCONSI18n from './I04CONCLIMCONSI18n'
import I04CONSCHAUFANI18n from './I04CONSCHAUFANI18n'
import I06SEPHYDI18n from './I06SEPHYDI18n'
import I07CALCPUISSRADI18n from './I07CALCPUISSRADI18n'
import I08CALCVOLEXPI18n from './I08CALCVOLEXPI18n'
import I09DIMCIRCI18n from './I09DIMCIRCI18n'
import I10DIABOUCECSI18n from './I10DIABOUCECSI18n'
import I10DIAMPUISSI18n from './I10DIAMPUISSI18n'
import I11PERCHADISCHAI18n from './I11PERCHADISCHAI18n'
import I11PERCHARESI18n from './I11PERCHARESI18n'
import I11PERCHARVARII18n from './I11PERCHARVARII18n'
import I12VOLINSTCHAUFI18n from './I12VOLINSTCHAUFI18n'
import I13VENTCHAUFFIOULI18n from './I13VENTCHAUFFIOULI18n'
import I13VENTCHAUFGAZI18n from './I13VENTCHAUFGAZI18n'
import I14V3VREGULI18n from './I14V3VREGULI18n'
import I14V2VREGULI18n from './I14V2VREGULI18n'
import I16DIMADOUCISSEURECSI18n from './I16DIMADOUCISSEURECSI18n'
import I16DIMADOUCISSEURPRIMI18n from './I16DIMADOUCISSEURPRIMI18n'
import I17TARIFC16I18n from './I17TARIFC16I18n'
import I17INFPARCONSEPI18n from './I17INFPARCONSEPI18n'
import I18VENTGAINEI18n from './I18VENTGAINEI18n'
import customProjectI18n from './customProjectI18n'

// AUTOMATIC FROM GENERATOR
import I21RENDETASI18n from './I21RENDETASI18n'
import I04CALCULGSIMPI18n from './I04CALCULGSIMPI18n'
import I04CALCULGDETAI18n from './I04CALCULGDETAI18n'
import I04CALCULGDETAItemI18n from './I04CALCULGDETAItemI18n'
import I15MASVOLAPHUMLI18n from './I15MASVOLAPHUMLI18n'
import I15TEMPRELEVEI18n from './I15TEMPRELEVEI18n'
import I15HYDROACCUI18n from './I15HYDROACCUI18n'
import I15TEMPLIMITBOISI18n from './I15TEMPLIMITBOISI18n'
import I15DIMSILOBOISI18n from './I15DIMSILOBOISI18n'
import I15TAUXCOUVBOISI18n from './I15TAUXCOUVBOISI18n'
import I13VENTCHAUFBOISI18n from './I13VENTCHAUFBOISI18n'
import I10DIAEFCOLI18n from './I10DIAEFCOLI18n'
//[I18N_ADD_IMPORT]
import UserProfileI18n from './UserProfileI18n'
// projet

import database from './database'
import mapI18n from './mapI18n'
import mailI18n from './mailI18n'
import ratingI18n from './ratingI18n'

import section from './section'
import projectsI18 from './projectsI18'
import P01CREALOGCOL18n from './P01CREALOGCOL18n'
import subI18n from './subI18n'

export default {
  ...errorCode,
  ...splashI18n,
  ...common,
  ...cguI18n,
  ...ratingI18n,
  ...section,
  ...projectsI18,
  ...mailI18n,
  ...webI18n,
  ...signinI18n,
  ...I00DebgazI18n,
  ...I00RELGAZPUISSI18n,
  ...I00DIMLIGNEGAZI18n,
  ...I01TEMPATTI18n,
  ...I01DEPBOUCECSI18n,
  ...I01EVACONSSYSTECSI18n,
  ...I01EVACONSSYSTECS2I18n,
  ...I01EVAECSQUALII18n,
  ...I01EVAECSQUALI2I18n,
  ...I01EVAECSQUALI3I18n,
  ...I02CHOIXENERCHAUFI18n,
  ...I02COSTENERI18n,
  ...I03PSYCHROAIRI18n,
  ...I04DIMPUISSCHAUDI18n,
  ...I04DIMPUISCONSI18n,
  ...I04CONSCHAUFANI18n,
  ...I04CONCLIMCONSI18n,
  ...I04CONVVOLENERI18n,
  ...I06SEPHYDI18n,
  ...I07CALCPUISSRADI18n,
  ...I08CALCVOLEXPI18n,
  ...I09DIMCIRCI18n,
  ...I10DIABOUCECSI18n,
  ...I10DIAMPUISSI18n,
  ...I11PERCHADISCHAI18n,
  ...I11PERCHARESI18n,
  ...I11PERCHARVARII18n,
  ...I12VOLINSTCHAUFI18n,
  ...I13VENTCHAUFFIOULI18n,
  ...I13VENTCHAUFGAZI18n,
  ...I14V2VREGULI18n,
  ...I14V3VREGULI18n,
  ...I16DIMADOUCISSEURECSI18n,
  ...I16DIMADOUCISSEURPRIMI18n,
  ...customProjectI18n,
  ...I17TARIFC16I18n,
  ...I17INFPARCONSEPI18n,
  ...I18VENTGAINEI18n,
  ...mapI18n,
  ...database,
  ...subI18n,
  ...P01CREALOGCOL18n,
  // AUTOMATIC FROM GENERATOR
  ...I21RENDETASI18n,
  ...I04CALCULGSIMPI18n,
  ...I04CALCULGDETAI18n,
  ...I04CALCULGDETAItemI18n,
  ...I15MASVOLAPHUMLI18n,
  ...I15TEMPRELEVEI18n,
  ...I15HYDROACCUI18n,
  ...I15TEMPLIMITBOISI18n,
  ...I15DIMSILOBOISI18n,
  ...I15TAUXCOUVBOISI18n,
  ...I13VENTCHAUFBOISI18n,
  ...I10DIAEFCOLI18n,
  //[I18N_ADD_IMPORT_INCLUDE]
  ...UserProfileI18n
}
